module.exports = __webpack_public_path__ + "static/Podcast02-dbc5ae764727b0c9cc083834cd92474d.jpg";